<template>
  <img
    v-if="(source != undefined && source !== '') || assetSource !== ''"
    class="imagecomponent"
    :src="assetInfo === undefined ? source : assetSource"
    :alt="alt"
  />
</template>
<script setup lang="ts">
import type { IImageComponent } from '@/interfaces/components/IImageComponent'
import { getImagePath } from '@/application/helpers/pathHelper'

const { alt, assetInfo, source } = defineProps<IImageComponent>()

const assetSource = ref<string>('')

onMounted(async () => {
  if (assetInfo !== undefined) {
    assetSource.value = await getImagePath(assetInfo)
  }
})
</script>
